export function clearUrlParams() {
  window.history.pushState({}, '', window.location.pathname);
}
